import { TextInput } from 'flowbite-react';
import { useState } from 'react';
import { HiEye, HiEyeSlash } from 'react-icons/hi2';

export interface PasswordInputProps {
  id?: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoFocus,
  disabled,
  required,
  className = '',
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`w-72 relative ${className}`}>
      <TextInput
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
        required={required}
        theme={{
          addon: 'border-none bg-transparent p-0 m-0 w-0',
          field: {
            base: 'relative',
            input: {
              withAddon: {
                on: 'rounded-lg pl-10',
                off: 'rounded-lg',
              },
            },
          },
        }}
        addon={
          <button
            type="button"
            aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
            aria-pressed={visible}
            onClick={() => setVisible((v) => !v)}
            className="text-gray-500 hover:text-gray-700 absolute left-3 top-1/2 -translate-y-1/2 z-10"
          >
            {visible ? (
              <HiEyeSlash className="w-4 h-4" />
            ) : (
              <HiEye className="w-4 h-4" />
            )}
          </button>
        }
      />
    </div>
  );
};
